export default __webpack_public_path__ + "static/media/fwd.2a124e72.jpg";